import { apiClient } from '@/api/http/client'
import type { ApiResponse } from '@/api/http/types'
import type { ISensemakerListResponse } from '@brushfire/types'

export async function fetchSensemakerList(): Promise<ISensemakerListResponse> {
  const { data } = await apiClient.get<ApiResponse<ISensemakerListResponse>>(
    '/api/v1/platform/sensemakers',
  )
  if (!data.data) {
    throw new Error('Sensemaker list response missing data')
  }
  return data.data
}
